// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1o02N","header":"ClearentDisclaimer_header__1b5V8","inner":"ClearentDisclaimer_inner__3qIkU"};